var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{key:_vm.$route.params.type,staticClass:"row"},[_c('post-list',{key:_vm.account}),_vm._v(" "),_c('div',{staticClass:"plus-col-main-message"},[_c('router-view',{key:_vm.account})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }